import axiosClient from "../../../shared/lib/axiosClient";
import { COURSE_API_BASE } from "../../../shared/utils/apiConfig";
import type { Course, CourseDetail, CourseResponse, CoursesResponse } from "../types";
import type { PurchaseCourse, PurchaseCourseResponse } from "../types";

// Lists all published courses
export const getCourses = async (signal?: AbortSignal): Promise<Course[]> => {
    const { data } = await axiosClient.get<CoursesResponse>(`${COURSE_API_BASE}/`, { signal });

    // An unexpected response is an error, not an empty list
    if (!data.success || !Array.isArray(data.courses)) {
        throw new Error("Unexpected response from the courses endpoint");
    }
    return data.courses;
};

// Returns null when the course doesn't exist
export const getCourse = async (
    courseId: string,
    signal?: AbortSignal
): Promise<CourseDetail | null> => {
    const { data } = await axiosClient.get<CourseResponse>(
        `${COURSE_API_BASE}/${courseId}`,
        { signal }
    );

    return data.success && data.course ? data.course : null;
};

// Enrolls the logged-in user (the session cookie is sent by axiosClient)
export const enrollInCourse = async (courseId: string): Promise<void> => {
    await axiosClient.post(`${COURSE_API_BASE}/enroll/${courseId}`);
};


// Returns null when the course doesn't exist
export const getPurchaseCourse = async (
    courseId: string,
    signal?: AbortSignal
): Promise<PurchaseCourse | null> => {
    const { data } = await axiosClient.get<PurchaseCourseResponse>(
        `${COURSE_API_BASE}/purchase/${courseId}`,
        { signal }
    );

    return data.success && data.course ? data.course : null;
};